import { render, staticRenderFns } from "./apiariesChart.vue?vue&type=template&id=cdbbc1e4&"
import script from "./apiariesChart.vue?vue&type=script&lang=js&"
export * from "./apiariesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports